module.exports = __webpack_public_path__ + "media/images/alee-bdb3c0c94526ca774811564f4d751bfb.png";